import { RequestErrorText } from '../../../../features/error-reporting/views/RequestIdActions';
import React, { useState } from 'react';
import { Alert, Button, Input, Popover, Tooltip, Typography, theme } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useCustomerReference } from '../../viewmodels/queries/useCustomerReference';

// Staff display only. Never import into message/document payload builders.
export function CustomerReference({ value, empty = false }) {
  const { token } = theme.useToken();
  if (!value) return empty ? <span>—</span> : null;
  return <Tooltip title={'Customer ref: ' + value}><span style={{ display: 'inline-block', maxWidth: '100%', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', verticalAlign: 'middle', fontSize: 12, fontWeight: 400, color: token.colorTextSecondary }}>Ref {value}</span></Tooltip>;
}
export function CustomerReferenceEditor(props) {
  const vm = useCustomerReference(props), [open, setOpen] = useState(false);
  return <div style={{ minWidth: 0 }}>
    <CustomerReference value={vm.current} />
    {vm.editable && <Popover open={open} onOpenChange={setOpen} trigger="click" content={<div style={{ width: 280 }}>
      <Typography.Text>Customer ref</Typography.Text>
      <Input aria-label="Customer reference" value={vm.text} maxLength={100} disabled={vm.busy} onChange={event => vm.setText(event.target.value)} />
      {vm.error && <Alert type="warning" message={<RequestErrorText text={vm.error} />} />}
      <Button type="primary" loading={vm.busy} onClick={async () => { if (await vm.save()) setOpen(false); }}>Save</Button>
    </div>}><Button type="text" size="small" icon={<EditOutlined />} aria-label="Edit customer reference">{!vm.current && 'Add customer ref'}</Button></Popover>}
    {!vm.editable && vm.error && <Typography.Text type="warning"><RequestErrorText text={vm.error} /></Typography.Text>}
  </div>;
}
